var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSocialMediaFacebookNew = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 25,
  fill: "none",
  viewBox: "0 0 25 25"
}), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_7568_1513)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M10.52 24.586C4.82 23.566.5 18.646.5 12.706.5 6.104 5.9.704 12.5.704s12 5.4 12 12c0 5.94-4.32 10.86-10.02 11.88l-.66-.54h-2.64z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0062E0",
  d: "m17.18 16.065.54-3.36h-3.18v-2.34c0-.96.36-1.68 1.8-1.68h1.56v-3.06c-.84-.12-1.8-.24-2.64-.24-2.76 0-4.68 1.68-4.68 4.68v2.64h-3v3.36h3v8.46a11 11 0 0 0 3.96 0v-8.46z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_7568_1513"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.5.705h24v24H.5z"
})))));
export { SvgIconSocialMediaFacebookNew as ReactComponent };